import { APP_URLS } from '@neo/constants'

export const redirectUnauthenticatedUserToLogIn = (
  appName,
  redirectUrl = `${APP_URLS.AUTH}sign-in?redirectApp=${appName}`
) => {
  window.location.replace(redirectUrl)
}
